import { render, staticRenderFns } from "./GridPrice.vue?vue&type=template&id=34ef8b2e&"
import script from "./GridPrice.vue?vue&type=script&lang=js&"
export * from "./GridPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports